'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _feisList = require('../../../feis-list');

var _feisList2 = _interopRequireDefault(_feisList);

var _starHelp = require('../../../feis-list/star-help');

var _starHelp2 = _interopRequireDefault(_starHelp);

var _one = require('../one');

var _one2 = _interopRequireDefault(_one);

var _create = require('../create');

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompletedFeiseannaController = function CompletedFeiseannaController(config, fFeisService) {
  var _this = this;

  _classCallCheck(this, CompletedFeiseannaController);

  this.config = config;
  this._ = { fFeisService: fFeisService };
  var now = new Date().getTime();

  this.loading = true;

  fFeisService.all({ params: { include_past: 1 } }).then(function (feiseanna) {
    _this.feiseanna = feiseanna;
    _this.pastFeiseannaExist = feiseanna.some(function (f) {
      return f.feis.dt_end < now;
    });
    _this.loading = false;
  }).catch(function () {
    return _this.loading = false;
  });
};

exports.default = angular.module('ifeis.routes.feiseanna.completed', ['ui.router', 'ngMaterial', 'ifeis.feis-list', 'ifeis.feis-star', 'ifeis.routes.feiseanna.create', 'ifeis.routes.feiseanna.one']).config(function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('feiseanna.completed', {
    url: '/completed',
    controller: 'CompletedFeiseannaController',
    controllerAs: 'completedFeiseanna',
    template: require('./tpl.html'),
    ncyBreadcrumb: {
      label: 'Completed'
    }
  });
}).controller('CompletedFeiseannaController', CompletedFeiseannaController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/completed/index.js
// module id = 535
// module chunks = 0